// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const NavRightArrow = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M14.158 5.956a.97.97 0 0 1-.307.731l-4.444 4.444a1.06 1.06 0 0 1-.335.232.888.888 0 0 1-.362.082c-.292 0-.526-.09-.704-.273a.889.889 0 0 1-.274-.663c0-.15.03-.285.09-.404.054-.113.127-.216.218-.307L9.571 8.26l2.263-2.078.424.622-2.66.143H1.875c-.31 0-.558-.09-.745-.273-.187-.182-.28-.422-.28-.718s.093-.535.28-.718c.187-.182.435-.273.745-.273h7.725l2.659.143-.424.622-2.263-2.078-1.531-1.53a1.082 1.082 0 0 1-.219-.315.847.847 0 0 1-.089-.397c0-.264.092-.485.274-.663.178-.182.412-.273.704-.273.25 0 .48.102.69.307l4.45 4.444c.206.2.308.444.308.731Z"
			fill="#fff"
			fillOpacity={0.4}
		/>
	</svg>
);
export default NavRightArrow;
